import { win } from "@gr-common/async/namespaces";
export * from "../lib/nexus/index.js";
import * as defines from "@gr-common/async/nexus";
const defineEvent = defines.defineEvent;
const defineStore = defines.defineStore;
const defineFunction = defines.defineFunction;
const defineNamespace = defines.defineNamespace;
const forServer = () => createProxy(createStore(name)[1], configAsync);
const otto = import.meta.env.SSR ? forServer() : win.otto ?? {};
export {
  defineEvent,
  defineFunction,
  defineNamespace,
  defineStore,
  otto
};
